export default __webpack_public_path__ + "media/react/gre/adaptive_prep_v2/assets/pencil-c136cbdfb82512f7fddc38ca79761398.svg";